export const NO_OF_ROWS = 6;
export const NO_OF_COLS = 6;


export const ROW_HEADERS = [
    {
        value: "Totalitarian",
        weight: 3
    },
    {
        value: "Authoritarian",
        weight: 2
    },
    {
        value: "Statist",
        weight: 1
    },
    {
        value: "Liberalism",
        weight: -1
    },
    {
        value: "Libertarianism",
        weight: -2
    },
    {
        value: "Anarchism",
        weight: -3
    }];
export const COL_HEADERS = [
    {
        value: "Communist",
        weight: -3
    },
    {
        value: "Socialist",
        weight: -2
    },
    {
        value: "Welfarist",
        weight: -1
    },
    {
        value: "Regulationist",
        weight: 1
    },
    {
        value: "Capitalist",
        weight: 2
    },
    {
        value: "Laissez Faire",
        weight: 3
    }];

export const POST_JOURNALIST_SPECTRUM_API = "http://localhost:3001/journalism_spectrum";

export const RESULTS_RUOTE = "/results";

export const MAX_JOURNO_CIRCLE_IN_GRID = 3;